import React from "react";
import { useTranslation } from 'next-i18next';
import Image from "next/image";
import { TextHeadingTwo } from "styles/typography";
import { OfferingsWrapper, OfferingsList, OtherOfferingsWrapper } from "./offerings.styles";
import { OfferingsList1, OfferingsList2, OtherOfferings1 } from "./offerrings.utils";

const Offerings = () => {
   const { t } = useTranslation('common');
   const offeringsList1 = OfferingsList1();
   const offeringsList2 = OfferingsList2();
   return (
      <OfferingsWrapper>
         <TextHeadingTwo center mw="670" style={{ margin: "auto", color: "#FFF" }}>
            {t('offer-title')}
         </TextHeadingTwo>

         <div>
            {offeringsList1.map((item) => (
               <OfferingsList key={item.id}>
                  <li>
                     <Image src={item.icon} height={58} width={58} alt={item.title} />
                     <div>
                        <h3>{item.title}</h3>
                        <p>{item.description}</p>
                     </div>
                  </li>
               </OfferingsList>
            ))}

            {offeringsList2.map((item) => (
               <OfferingsList key={item.id}>
                  <li>
                     <Image src={item.icon} height={58} width={58} alt={item.title} />
                     <div>
                        <h3>{item.title}</h3>
                        <p>{item.description}</p>
                     </div>
                  </li>
               </OfferingsList>
            ))}
         </div>
      </OfferingsWrapper>
   );
};

const OtherOfferings = () => {
   const otherOfferings = OtherOfferings1();
   return (
      <OtherOfferingsWrapper>
         {otherOfferings.map((item) => (
            <OfferingsList key={item.id}>
               <li>
                  <Image src={item.icon} height={58} width={58} alt={item.title} />
                  <div>
                     <h3>{item.title}</h3>
                     <p>{item.description}</p>
                  </div>
               </li>
            </OfferingsList>
         ))}
      </OtherOfferingsWrapper>
   );
};

export { Offerings, OtherOfferings };
